import { FETCH_FORUM_DATA_SUCCESS } from '../actions/fetch-forum-data';
import { UPDATE_FORUM_DATA_SUCCESS } from '../actions/update-forum-data';
import { SET_FORUM_DATA } from '../actions/set-forum-data';

export default function forumData(state = {}, action) {
  switch (action.type) {
    case FETCH_FORUM_DATA_SUCCESS:
    case UPDATE_FORUM_DATA_SUCCESS:
    case SET_FORUM_DATA:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/forum-data.js